import React, { useEffect, useState, useMemo } from "react";
import { Search } from "lucide-react";
import { Spinner } from "./ui/kit";
import api from "../lib/api";

// Výběr klientů firmy se zaškrtávátky. `value` = pole client_id, `onChange(ids)`.
export default function ClientPicker({ value = [], onChange }) {
  const [clients, setClients] = useState(null);
  const [q, setQ] = useState("");
  const sel = useMemo(() => new Set(value), [value]);

  useEffect(() => {
    api.get("/api/clients", { params: { limit: 200 } })
      .then(({ data }) => setClients(data.items || []))
      .catch(() => setClients([]));
  }, []);

  const toggle = (id) => {
    const next = new Set(sel);
    next.has(id) ? next.delete(id) : next.add(id);
    onChange(Array.from(next));
  };

  const shown = (clients || []).filter((c) =>
    !q || (c.display_name || "").toLowerCase().includes(q.toLowerCase()) ||
    (c.adresa?.mesto || "").toLowerCase().includes(q.toLowerCase()));

  return (
    <div>
      <div className="relative mb-2">
        <Search size={14} className="absolute left-3 top-1/2 -translate-y-1/2 text-muted" />
        <input value={q} onChange={(e) => setQ(e.target.value)} placeholder="Hledat klienta…"
          data-testid="clientpicker-search" className="field pl-8 h-9 text-[13px]" />
      </div>
      <div className="rounded-card border border-line-strong max-h-[280px] overflow-y-auto">
        {clients === null ? (
          <div className="p-6 flex justify-center"><Spinner /></div>
        ) : shown.length === 0 ? (
          <div className="p-4 text-[12.5px] text-muted text-center">Žádný klient neodpovídá.</div>
        ) : shown.map((c) => (
          <label key={c.id} data-testid={`clientpicker-item-${c.id}`}
            className="flex items-center gap-3 px-3 py-2.5 border-b border-line-softer last:border-0 cursor-pointer hover:bg-inputbg">
            <input type="checkbox" checked={sel.has(c.id)} onChange={() => toggle(c.id)}
              className="h-4 w-4 accent-[#ff6a13]" data-testid={`clientpicker-check-${c.id}`} />
            <span className="min-w-0 flex-1">
              <span className="block text-[13px] font-600 text-ink truncate">{c.display_name}</span>
              {c.adresa?.mesto && <span className="block text-[11px] text-muted">{c.adresa.mesto}</span>}
            </span>
          </label>
        ))}
      </div>
    </div>
  );
}
